import { gql } from '@apollo/client';

export default gql`
  mutation changePassword($currentPassword: String!, $password: String!) {
    changePassword(input: { currentPassword: $currentPassword, password: $password }) {
      success
    }
  }
`;
